// extracted by mini-css-extract-plugin
var _1 = "src-pages-dashboard-widgets-base-static-widget-__staticWidget--enVShSECHyOBuJUZe9rd";
export { _1 as "staticWidget" }
